export const pendingHeartRunnerListState = {
    isLoading: false,
    pendingHeartRunnerList: [],
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
    regionList:[],
}